<form #formStep="ngForm" novalidate autocomplete="off">
    <div class="bg-blue-gradient">
        <i class="icon-apple d-none d-md-block"></i>
        <i class="icon-medal d-none d-md-block"></i>

        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap align-items-center py-4 pb-md-5">
                        <div class="col-auto">
                            <label class="number">{{ step }}</label>
                        </div>
                        <div class="col-auto flex-shrink-1">
                            <p class="text-blue mb-0">
                                {{ question.description }}
                            </p>
                        </div>
                    </div>
                    <div class="options pb-4 pb-md-0">
                        <thr-radio-group [name]="'option'" [(ngModel)]="selected" (ngModelChange)="onSelectedChange()" [required]="true">
                            <ng-template ngFor let-option [ngForOf]="question.options" let-i="index">
                                <thr-radio-button [size]="128" [value]="option" [disabled]="isDisabled(i)">
                                    <ng-container [ngSwitch]="i">
                                        <i class="icon-apple" *ngSwitchCase="0"></i>
                                        <i class="icon-book" *ngSwitchCase="1"></i>
                                        <i class="icon-bookmark" *ngSwitchCase="2"></i>
                                        <i class="icon-hat" *ngSwitchCase="3"></i>
                                        <i class="icon-medal" *ngSwitchDefault></i>
                                    </ng-container>
                                    <strong>{{ option.description }}</strong>
                                </thr-radio-button>
                            </ng-template>
                        </thr-radio-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="container">
    <div class="row align-items-center mt-3 mt-md-5 mb-4">
        <div class="col-12 col-sm-2 col-md-4">
            <p class="mb-0">
                {{ 'test.question' | translate }}
                <strong>{{ stepNumber }}</strong> {{ 'test.of' | translate }}
                {{ totalSteps }}
            </p>
        </div>
        <div class="col-12 col-sm-5 col-md-4 mt-3 mt-sm-0">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onBack()" *ngIf="!hideBack">
                {{ 'test.back' | translate }}
            </button>
        </div>
        <div class="col-12 col-sm-5 col-md-4 mt-3 mt-sm-0">
            <button
                type="button"
                class="full-width mat-elevation-z0"
                mat-raised-button
                color="blue"
                [disabled]="!formStep.valid"
                (click)="onClick()"
            >
                <ng-container *ngIf="!isLastQuestion">{{ 'test.next' | translate }}</ng-container>
                <ng-container *ngIf="isLastQuestion">{{ 'test.finish' | translate }}</ng-container>
            </button>
        </div>
    </div>
</div>
